/**
 * Train station mapping (~290KB) loaded on demand so it stays out of the
 * homepage and flight bundles.
 */
export class TrainStationCatalog {
  constructor(loader = () => import('./train_all_station_mapping.json')) {
    this.loader = loader;
    this.stations = null;
    this.pending = null;
  }

  loadStations() {
    if (this.stations) return Promise.resolve(this.stations);
    if (!this.pending) {
      this.pending = Promise.resolve()
        .then(() => this.loader())
        .then((mod) => {
          const data = mod && mod.default ? mod.default : mod;
          this.stations = Array.isArray(data?.stations) ? data.stations : [];
          return this.stations;
        })
        .catch((error) => {
          console.error('Train station mapping failed to load:', error);
          this.pending = null;
          return [];
        });
    }
    return this.pending;
  }

  getLoadedStations() {
    return this.stations || [];
  }
}

export const trainStationCatalog = new TrainStationCatalog();
